import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postLogin } from '../Api'

export default generateApiAction({
  baseType: Types.AUTH.LOGIN,
  api: postLogin,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/auth/LoginAction.js